import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { ConvertTreatmentTemplatePayload, ConvertTreatmentTemplateResponse } from "../schemas/Treatment";

export const usePostConvertTreatmentTemplate = () => {
  const client = useApiClient();

  return useMutation<ConvertTreatmentTemplateResponse, Error, ConvertTreatmentTemplatePayload>({
    mutationFn: args => client.postConvertTreatmentTemplate(args),
  });
};
